export const BASE_URL = process.env.REACT_APP_BACKEND_URL_LIVE;
export const STUDENT_BASE_URL = process.env.REACT_APP_BACKEND_URL_LIVE_STUDENT;
export const FILE_UPLOAD_URL = "https://elearning.qhseinternational.com/";
export const API_END_POINTS = {
  diplomaDate: BASE_URL + "diploma/date-list",
  diplomaFindLocation: BASE_URL + "diploma/find-location",
  diplomaFindSlot: BASE_URL + "diploma/find-slot",
  diplomaSaveAppointment: BASE_URL + "diploma/save-appointment",
  /////end diploma///////////////
  appointmentDate: BASE_URL + "appointment/date-list",
  appointmentFindLocation: BASE_URL + "appointment/find-location",
  appointmentFindSlot: BASE_URL + "appointment/find-slot",
  appointmentSaveAppointment: BASE_URL + "appointment/save-appointment",
  //////////////////end appointment
  upload_file: FILE_UPLOAD_URL + "upload.php",
  login: BASE_URL + "auth/login",
  logout: BASE_URL + "auth/logout", 
  updateProfile: BASE_URL + "auth/update-profile",
  updatePassword: BASE_URL + "auth/update-password",
  adddiary: BASE_URL + "add-diary",
  diarylist: BASE_URL + "diary-list",
  deletediary: BASE_URL + "diary-delete",
  managerList: BASE_URL + "manager-list",
  studentList: BASE_URL + "student-list",
  mainCourse: BASE_URL + "main-course",
  licenseExpiryList: BASE_URL + "license-expiry-list",
  courseList: BASE_URL + "course-list",
  enrollmentReview: BASE_URL + "enrollment-review",
  manager: BASE_URL + "manager",
  student: BASE_URL + "student",
  enrollStudent: BASE_URL + "enrollment",
  adminDashboard: BASE_URL + "admin-dashboard",
  enrollmentStatistics: BASE_URL + "enrollment-statistics",
  learnerProgress: BASE_URL + "learner-progress",
  loadUnit: BASE_URL + "load-unit",
  resource: BASE_URL + "resource",
  qualification: BASE_URL + "qualification",
  qualificationList: BASE_URL + "qualification-list",
  manageExam: BASE_URL + "exam-list",
  manageModule: BASE_URL + "manage-module",
  manageSubModule: BASE_URL + "sub-manage-module",
  manageQuestion: BASE_URL + "manage-question",
  multipleOption: BASE_URL + "multiple-option",
  certificateList: BASE_URL + "certificate-list",
  course: BASE_URL + "course",
  learningOutcome: BASE_URL + "learning-outcome",
  learningOutcomeList: BASE_URL + "learning-outcome-list",
  
  learningOutcomeDetail: BASE_URL + "learning-outcome-detail",
  learningOutcomeDetailAdd: BASE_URL + "learning-outcome-detail-add",
  learningOutcomeDetailSingle: BASE_URL + "learning-outcome-detail-single",
  showArticle: BASE_URL + "single-article",
  Article: BASE_URL + "article",
  Video: BASE_URL + "video",
  VideoPlay: BASE_URL + "play-video",
  showCaseStudy: BASE_URL + "show-case-study",
  CaseStudy: BASE_URL + "case-study",
  showCaseStudy: BASE_URL + "single-case-study",
  sendMessage: BASE_URL + "send-message",
  longQuestionsResult: BASE_URL + "long-questions-result",
  uploadMocExamResult: BASE_URL + "upload-moc-exam-result",
  
  resultDetail: BASE_URL + "result-detail",
  submitMockExamMarks: BASE_URL + "submit-mockexam-marks",
  // student side api
  studentLogin: STUDENT_BASE_URL + "auth/login",
  studentUpdatePass: STUDENT_BASE_URL + "student-update-password",
  studentUpdateProfile: STUDENT_BASE_URL + "update-student",
  studentResource: STUDENT_BASE_URL + "resource-list",
  studentProgress: STUDENT_BASE_URL + "student-progress",
  sendForgetPassLink: STUDENT_BASE_URL + "auth/send-forget-password",
  studentMyCourse: STUDENT_BASE_URL + "my-course",
   
  studentFreeCourseTopic: STUDENT_BASE_URL + "my-courses/short-course-topic",
  studentFreeCourseTopicDetail: STUDENT_BASE_URL + "my-courses/short-course-topic-detail",
  studentFreeCourseDetailPdf: STUDENT_BASE_URL + "short-course-topic-detail-pdf",
  studentquestionPdf: STUDENT_BASE_URL + "my-courses/relevant-question-open",
  longQuestionsList: STUDENT_BASE_URL + "long-questions-list",
  submitLongQuestions: STUDENT_BASE_URL + "submit-long-questions",
  
  studentCourseTopic: STUDENT_BASE_URL + "my-courses/course-topic",
  studentCourseTopicDetail: STUDENT_BASE_URL + "my-courses/course-topic-detail",
  studentCourseOutcome: STUDENT_BASE_URL + "my-courses/course-outcome",
  studentCourseOutcomePdf: STUDENT_BASE_URL + "my-courses/course-outcome-pdf",
 
  studentSignUp: STUDENT_BASE_URL + "auth/signup",
  saveStudentTime: STUDENT_BASE_URL + "save-student-reading-time",
  studentMultipleQuestionList: STUDENT_BASE_URL + "multiple-questions-list",
  studentFinalQuizStart: STUDENT_BASE_URL + "final-quiz-start",
  studentFinalQuizSubmit: STUDENT_BASE_URL + "final-quiz-submit",
  studentSubmitQuiz: STUDENT_BASE_URL + "submit-quiz",
  studentExamCount: STUDENT_BASE_URL + "exam-count",
  studentExamResult: STUDENT_BASE_URL + "moc-exam-result",
  ////////
  courseParticipants: STUDENT_BASE_URL + "course-participants",
  courseCountryWise: STUDENT_BASE_URL + "course-country-wise",
  courseTask: STUDENT_BASE_URL + "course-task",
  teacherQuestions: STUDENT_BASE_URL + "teacher-question",
  addReply: STUDENT_BASE_URL + "add-reply",
  //admin
  adminParticipants: BASE_URL + "course-participants",
  task: BASE_URL + "course-task",
  taskDetails: BASE_URL + "course-task-details",
  teacherQuestion: BASE_URL + "teacher-question",
  courseGroup: BASE_URL + "group-list",
  deleteBatch: BASE_URL + "delete-batch",
  asignBatch: BASE_URL + "asign-batch",
  groupListDetails: BASE_URL + "group-list-details",
}; 